import { render, staticRenderFns } from "./AppGraficoRosca.vue?vue&type=template&id=2bac69e8&"
import script from "./AppGraficoRosca.vue?vue&type=script&lang=js&"
export * from "./AppGraficoRosca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports